import React from "react";
import { Box, Typography } from "@mui/material";

const EventTitle = ({ event }) => {
  const { name, address } = event || {};
  const { placeName } = address || {};

  return (
    <Box>
      <Typography variant="" paddingTop={"0px"}>
        {name}
      </Typography>
      <Typography color={"primary.lightText"}>{placeName}</Typography>
    </Box>
  );
};

export default EventTitle;
